// extracted by mini-css-extract-plugin
export var dropdown = "_fy-0";
export var imagePlaceholder = "_fy-2";
export var imageWrapper = "_fy-3";
export var productImage = "_fy-1";
export var truncateContainer = "_fy-4";
export var truncateText = "_fy-5";